// @ts-check
import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $buttons: this.el.querySelectorAll('.campaign-html-image-downloads__btn-copy-embed')
    };
  }

  addListeners() {
    this.dom.$buttons.forEach((button) =>
      button.addEventListener('click', this.copyEmbedCode)
    );
  }

  copyEmbedCode(e) {
    const elementId = e.srcElement.dataset.target;
    const copyText = document.getElementById(elementId);
    const textArea = document.createElement("textarea");

    textArea.value = copyText.textContent;
    document.body.appendChild(textArea);
    navigator.clipboard.writeText(textArea.value).then(() => {
      textArea.remove();
    });
  }
}

export default Module;
